import { createAsyncThunk } from "@reduxjs/toolkit";
import { applicationCheckListGetApi, commencementChecklistGetApi, drawingChecklistGetApi } from "../../Api/Project/DefaultServices/CheckListApi";
import { mapApplicationCheckListTypes } from "../Types/ChecklistTypes/ApplicationCheckListType";
import { mapCommencementCheckListTypes } from "../Types/ChecklistTypes/CommencementCheckListType";
import { mapDrawingCheckListTypes } from "../Types/ChecklistTypes/DrawingCheckListType";


// get all application checklist thunks.
export const getAllApplicationChecklist = createAsyncThunk('getAllApplicationChecklist', async (serviceId:number, { rejectWithValue }) => {
  try {
    // api
    const response = await applicationCheckListGetApi(serviceId);
    if (response.status) {
      return mapApplicationCheckListTypes(response.data);
    } else {
      // If the API returns a failure status, return the error message
      return rejectWithValue(response.error);
    }
  } catch (error: any) {
    // Handle the case where the API call itself throws an error
    return rejectWithValue('Failed to fetch alldetails');
  }
});


// get all CommencementChecklist thunks.
export const getAllCommencementChecklist = createAsyncThunk('getAllCommencementChecklist', async (serviceId:number, { rejectWithValue }) => {
  try {
    // api
    const response = await commencementChecklistGetApi(serviceId);
    if (response.status) {
      return mapCommencementCheckListTypes(response.data);
    } else {
      // If the API returns a failure status, return the error message
      return rejectWithValue(response.error);
    }
  } catch (error: any) {
    // Handle the case where the API call itself throws an error
    return rejectWithValue('Failed to fetch alldetails');
  }
});


// get all drawing checklist thunks.
export const getAllDrawingChecklist = createAsyncThunk('getAllDrawingChecklist', async (serviceId:number, { rejectWithValue }) => {
  try {
    // api
    const response = await drawingChecklistGetApi(serviceId);
    if (response.status) {
      return mapDrawingCheckListTypes(response.data);
    } else {
      // If the API returns a failure status, return the error message
      return rejectWithValue(response.error);
    }
  } catch (error: any) {
    // Handle the case where the API call itself throws an error
    return rejectWithValue('Failed to fetch alldetails');
  }
});
